import { render, staticRenderFns } from "./ioCard.vue?vue&type=template&id=07f201c1&scoped=true&"
import script from "./ioCard.vue?vue&type=script&lang=js&"
export * from "./ioCard.vue?vue&type=script&lang=js&"
import style0 from "./ioCard.vue?vue&type=style&index=0&id=07f201c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f201c1",
  null
  
)

export default component.exports